import { Timestamp } from "firebase/firestore";

export const enum KlaviyoIntegrationStatus {
  NOT_CONNECTED = "notConnected",
  CONNECTED = "connected",
}

export type KlaviyoDocument = {
  lastSynced?: Timestamp;
  secretPath?: string;
};
